module.exports = __webpack_public_path__ + "static/media/litho-1.011b668a.jpg";